import MkuIcon from './src/icon';

MkuIcon.install = function (Vue) {
  Vue.component(MkuIcon.name, MkuIcon);
};

export default MkuIcon;
